import { render, staticRenderFns } from "./TimeAndMoney.vue?vue&type=template&id=40070edc&scoped=true&"
import script from "./TimeAndMoney.vue?vue&type=script&lang=js&"
export * from "./TimeAndMoney.vue?vue&type=script&lang=js&"
import style0 from "./TimeAndMoney.vue?vue&type=style&index=0&id=40070edc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40070edc",
  null
  
)

export default component.exports